<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Acompanhamento Status",
    meta: [
      {
        name: "description",
        content: "Dashboard de acompanhamento de status exportado do Elastic/Kibana",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Acompanhamento Status",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Acompanhamento Status",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="iframe-container">
              <iframe 
                src="https://kibana.econocargo.net/app/dashboards#/view/230d8fdc-7901-42b0-9a2b-c925dc50990e?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A60000)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))&show-top-menu=true&show-query-input=true&show-time-filter=true" 
                height="800" 
                width="100%" 
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.iframe-container {
  width: 100%;
  height: 800px;
  overflow: hidden;
}
.iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
